@if (!loading()) {
  <div class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-5 pt-7">
    @for (categoryTree of articlesTree().childrenCategories; track categoryTree.categoryDoc?.id) {
      <div class="mx-3">
        <div class="w-full border-b-[1px]">
          <p class="px-4 py-2 text-[--neutral-600]">
            {{ categoryTree.categoryDoc?.data?.title ?? category()?.data?.title }}
          </p>
        </div>

        <ul class="flex flex-col gap-2">
          @for (article of categoryTree.articles; track article.id) {
            <li>
              <a
                [routerLink]="['/', languageService.current, article.id + '-' + (article.data.title | urlifyTitle)]"
                class="group text-[--color-link-default] hover:text-[--color-link-hover] active:text-[--color-link-active] visited:text-[--color-link-active] hover:bg-[--blue-50] active:bg-transparent px-2 py-1.5 rounded-lg transition-colors inline-flex gap-2 items-center"
              >
                <lib-svg
                  class="fill-[--color-link-default] group-hover:[&_svg]:fill-[--color-link-hover] group-active:[&_svg]:fill-[--color-link-active] group-visited:[&_svg]:fill-[--color-link-active]"
                  svg="fontawesome/file-lines-regular"
                />
                {{ article.data.title }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>
} @else {
  <ngx-skeleton-loader class="flex flex-col gap-2 [&_.skeleton-loader]:!h-5" count="5" />
}
